export const SalaryslipAddressData = [
    {
        title: 'from',
        name: 'ebazar',
        address: '111  Berkeley Rd',
        add: 'STREET ON THE FOSSE, Poland',
        email: 'Email: info@deoweb.com',
        number: 'Phone: +44 888 666 3333'
    }, {
        title: 'To:',
        name: 'Dylan Hunter',
        address: 'Digital Marketing',
        add: 'Employee ID: 00008',
        email: 'Joining Date: 15 Feb 2017',
        number: 'Phone: +66 243 456 789'
    }
  ]
  
  export const SalaryslipTable1Data = [
    {
        number: '1',
        title: 'Basic Salary',
        price: '$8000,00'
    },
    {
        number: '2',
        title: 'House Rent Allowance (H.R.A.)',
        price: '$50,00'
    },
    {
        number: '3',
        title: 'Conveyance',
        price: '$50,00'
    },
    {
        number: '4',
        title: 'Other Allowance',
        price: '$50,00'
    },
  ]
  
  export const SalaryslipTable2Data = [
    {
        number: '1',
        title: 'Tax Deducted at Source (T.D.S.)',
        price: '$15,00'
    },
    {
        number: '2',
        title: 'Provident Fund',
        price: '$200,00'
    },
    {
        number: '3',
        title: 'ESI',
        price: '$0,00'
    },
    {
        number: '4',
        title: 'Other Deductions',
        price: '$0,00'
    },
  ]